import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {updateLeadWatchers} from "../../../store/action/lead/lead";
import Lead from "../../../model/lead/Lead";
import Toast from "../../helper/Toast";
import User from "../../../model/user/User";
import {Option} from "ts-option";
import {RootState} from "../../../store/reducer/root/RootState";
import {getUser} from "../../../store/view/user";
import Watchers from "./Watchers";

interface ComponentProps {
	/**
	 * Lead.
	 */
	lead: Option<Lead>
}

interface ReduxProps {
	/**
	 * Lead watchers.
	 */
	watchers: User[]
}

interface DispatchProps {
	/**
	 * Update watchers action.
	 * @param {string} leadId
	 * @param {string[]} watchers
	 */
	updateWatchers: (leadId: string, watchers: string[]) => void;
}


type Props = ComponentProps & DispatchProps & ReduxProps

class LeadWatchers extends React.PureComponent<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onUpdate = this.onUpdate.bind(this);
	}

	render() {
		return (
			<Watchers watchers={this.props.watchers} onUpdateWatchers={this.onUpdate}/>
		);
	}

	onUpdate(updatedWatchers: string[]) {
		this.props.lead.map(l => {
			this.props.updateWatchers(l.id, updatedWatchers);
		})
	}

}

function mapStateToProps(state: RootState, props: ComponentProps) {
	const watchersIds = props.lead.map(lead => lead.watchers).getOrElse([]);
	return {
		watchers: watchersIds.map(wId => getUser(wId)).filter(u => u.isDefined).map(u => u.get)
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateWatchers: (leadId: string, watchers: string[]) => dispatch(
			updateLeadWatchers(
				leadId,
				watchers,
				() => Toast.success("Lead watchers updated", "Lead details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Lead details update"))
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadWatchers)